<template>
<div ref="test" class="item-list-section">
  <!-- <v-alert
    type="warning"
    dense
    v-if="hasItemsWithNoInventory"
  >Hay productos en el carrito que no tienen suficiente inventario en esta sucursal.</v-alert> -->
  <div id="itemsListContainer" style="height: 70vh; overflow: auto; overflow-x: hidden;">
    <v-simple-table class="cart-simple-table">
      <template v-slot:default>
        <thead>
          <tr class="cart-table-header">
            <th class="text-right">Cantidad</th>
            <th>Artículo</th>
            <th class="text-right">P. Unit</th>
            <th class="text-right">Total</th>
            <th class="text-center"></th>
          </tr>
        </thead>
        <item-list-item
          v-for="(item, index) in frontItemsList"
          :key="index"
          :item="item"
          :index="index"
        />
      </template>
    </v-simple-table>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import ItemListItem from './ItemListItem.vue';

export default {
  name: 'item-list',
  components: {
    ItemListItem,
  },
  computed: {
    ...mapGetters({
      productsList: 'productsList',
      itemsList: 'itemsList',
      selectedClient: 'selectedClient',
      itemToPreview: 'itemToPreview',
      frontItemsList: 'frontItemsList',
      hasItemsWithNoInventory: 'hasItemsWithNoInventory',
    }),
  },
  data: () => ({
    stompClient: null,
    ignoreInventory: false,
  }),
  methods: {
    clearItemsList() {
      this.$store.dispatch('clearItemsList');
    },
    scrollToItemsListBottom() {
      setTimeout(() => {
        const element = document.getElementById('itemsListContainer');
        element.scrollTop = (element.scrollHeight + 200);
      }, 50);
    },
  },
  mounted() {
    this.$store.subscribe((mutation) => {
      if (mutation.type === 'ADD_ITEM_TO_LIST') {
        // INFO: Cada vez que se agrega un articulo a la lista, correr el scroll hasta el fondo
        this.scrollToItemsListBottom();
      }
    });
    this.ignoreInventory = localStorage.getItem('ignoreInventory') === '1';
  },
};
</script>

<style lang="less" scoped>
.cart-table-header {
  background-color: rgba(0, 0, 0, 0.04);
  color: #333333;

  th {
    font-size: 0.875rem;
    font-weight: 700;
    text-transform: uppercase;
    padding: 8px;
  }
}

.cart-simple-table {
  /deep/ table {
    width: 100%;
    border-collapse: collapse;
  }

  /deep/ th:nth-child(1) {
    width: 8.333%;
  }

  /deep/ th:nth-child(2) {
    width: 50%;
  }

  /deep/ th:nth-child(3),
  /deep/ th:nth-child(4) {
    width: 16.666%;
  }

  /deep/ th:nth-child(5) {
    width: 8.333%;
  }
}

.item-list-title {
  padding: 0;
  font-size: 1.4rem;
}
.item-name {
  font-weight: 400;
  font-size: 1.1rem;
}
.edit-qty-modal {
  overflow: hidden !important;
}

@media (max-width: 599px) {
  .cart-simple-table {
    /deep/ thead {
      display: none;
    }
  }
}
</style>
